import { InsideType } from '../constants/enum';
import {
  CabinetFormularTA,
  CabinetFormularTAKC,
  CabinetFormularTBD,
  CabinetFormularTBDG45,
  CabinetFormularTBDGL1,
  CabinetFormularTBDGL2,
  CabinetFormularTBDGL3,
  CabinetFormularTBDTGL3,
  CabinetFormularTBR,
  CabinetFormularTBT,
  CabinetFormularTBTGL1,
  CabinetFormularTBTGL2,
  CabinetFormularTBTGL3,
  CabinetFormularTOTL,
  CabinetOptionTA,
  CabinetOptionTAKC,
  CabinetOptionTBD,
  CabinetOptionTBDG45,
  CabinetOptionTBDGL1,
  CabinetOptionTBDGL2,
  CabinetOptionTBDGL3,
  CabinetOptionTBDTGL3,
  CabinetOptionTBR,
  CabinetOptionTBT,
  CabinetOptionTBTGL1,
  CabinetOptionTBTGL2,
  CabinetOptionTBTGL3,
  CabinetOptionTOTL,
} from './formularCabinet';

export const listModule = [
  {
    id: 1,
    name: 'Tủ bếp dưới',
    glbUrl: '/assets/glb/TUBEPDUOIuv.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'lower',
    cabinetFormular: CabinetFormularTBD,
    cabinetOption: CabinetOptionTBD,
    default: {
      width: 0.8,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
    },
    limit: {
      width: { min: 0.3, max: 1.2 },
      height: { min: 0.79, max: 0.88 },
      depth: { min: 0.59, max: 0.68 },
    },
  },
  {
    id: 2,
    name: 'Tủ bồn rửa',
    glbUrl: '/assets/glb/TU-BON-RUA.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'sink',
    cabinetFormular: CabinetFormularTBR,
    cabinetOption: CabinetOptionTBR,
    default: {
      width: 0.8,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
    },
  },
  {
    id: 3,
    name: 'Tủ ốp tủ lạnh',
    glbUrl: '/assets/glb/TOTL.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'totl',
    cabinetFormular: CabinetFormularTOTL,
    cabinetOption: CabinetOptionTOTL,
    default: {
      width: 1,
      height: 1.8,
      depth: 0.8,
      thickness: 0.017,
    },
  },
  {
    id: 4,
    name: 'Tủ bếp trên',
    glbUrl: '/assets/glb/TBT.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'upper',
    cabinetFormular: CabinetFormularTBT,
    cabinetOption: CabinetOptionTBT,
    default: {
      width: 0.8,
      height: 0.8,
      depth: 0.35,
      thickness: 0.017,
    },
    limit: {
      width: { min: 0.3, max: 1.2 },
      height: { min: 0.79, max: 0.88 },
      depth: { min: 0.59, max: 0.68 },
    },
  },
  {
    id: 5,
    name: 'Tủ áo',
    glbUrl: '/assets/glb/TA.glb',
    size: '300 - 2000 mm',
    minY: 0,
    moduleType: 'lower',
    cabinetFormular: CabinetFormularTA,
    cabinetOption: CabinetOptionTA,
    default: {
      width: 1.0,
      height: 1.9,
      depth: 0.6,
      thickness: 0.017,
    },
    limit: {
      width: { min: 0.3, max: 2 },
      height: { min: 1, max: 2 },
      depth: { min: 0.5, max: 0.68 },
    },
  },
  {
    id: 6,
    name: 'Tủ áo khuyết cột',
    glbUrl: '/assets/glb/TAKC.glb',
    size: '300 - 2000 mm',
    minY: 0,
    moduleType: 'wardrobe',
    cabinetFormular: CabinetFormularTAKC,
    cabinetOption: CabinetOptionTAKC,
    default: {
      width: 1.4,
      height: 2,
      depth: 0.6,
      thickness: 0.017,
    },
    type: 1, // tạm để type tủ khuyết cột là 1
  },
  {
    id: 7,
    name: 'TB dưới GL1',
    glbUrl: '/assets/glb/TBDGL2.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'corner_lower',
    cabinetFormular: CabinetFormularTBDGL1,
    cabinetOption: CabinetOptionTBDGL1,
    default: {
      width: 1.2,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
      rongK1: 1,
      rongK2: 1,
    },
  },
  {
    id: 8,
    name: 'TB dưới GL2',
    glbUrl: '/assets/glb/TBDGL2.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'corner_lower',
    cabinetFormular: CabinetFormularTBDGL2,
    cabinetOption: CabinetOptionTBDGL2,
    default: {
      width: 1.2,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
      rongK1: 1,
      rongK2: 1,
    },
  },
  {
    id: 9,
    name: 'TB dưới GL3',
    glbUrl: '/assets/glb/TBDGL3.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'corner_lower',
    cabinetFormular: CabinetFormularTBDGL3,
    cabinetOption: CabinetOptionTBDGL3,
    default: {
      width: 1.2,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
      rongK1: 1,
      rongK2: 1,
    },
  },
  {
    id: 10,
    name: 'TB dưới góc 45 độ',
    glbUrl: '/assets/glb/TBDGX.glb',
    size: '300 - 600 mm',
    minY: 0,
    moduleType: 'corner_lower',
    cabinetFormular: CabinetFormularTBDG45,
    cabinetOption: CabinetOptionTBDG45,
    default: {
      width: 1.2,
      height: 0.87,
      depth: 0.579,
      thickness: 0.017,
      rongK1: 1,
      rongK2: 1,
    },
  },
  {
    id: 11,
    name: 'TB trên GL1',
    glbUrl: '/assets/glb/TBTGL1.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'upper',
    cabinetFormular: CabinetFormularTBTGL1,
    cabinetOption: CabinetOptionTBTGL1,
    default: {
      width: 1.2,
      height: 0.8,
      depth: 0.35,
      thickness: 0.017,
      rongK1: 0.8,
      rongK2: 0.8,
    },
  },
  {
    id: 12,
    name: 'TB trên GL2',
    glbUrl: '/assets/glb/TBTGL1.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'upper',
    cabinetFormular: CabinetFormularTBTGL2,
    cabinetOption: CabinetOptionTBTGL2,
    default: {
      width: 1.2,
      height: 0.8,
      depth: 0.35,
      thickness: 0.017,
      rongK1: 0.8,
      rongK2: 0.8,
    },
  },
  {
    id: 13,
    name: 'TB trên GL3',
    glbUrl: '/assets/glb/TBTGL3.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'upper',
    cabinetFormular: CabinetFormularTBTGL3,
    cabinetOption: CabinetOptionTBTGL3,
    default: {
      width: 1.2,
      height: 0.8,
      depth: 0.35,
      thickness: 0.017,
      rongK1: 0.8,
      rongK2: 0.8,
    },
  },
  {
    id: 14,
    name: 'TB đụng trần GL3',
    glbUrl: '/assets/glb/TBDTGL3.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'ceiling',
    cabinetFormular: CabinetFormularTBDTGL3,
    cabinetOption: CabinetOptionTBDTGL3,
    default: {
      width: 1.2,
      height: 0.4,
      depth: 0.35,
      thickness: 0.017,
      rongK1: 0.8,
      rongK2: 0.8,
    },
  },
  {
    id: 15,
    name: 'TB đụng trần',
    glbUrl: '/assets/glb/TBT.glb',
    size: '300 - 600 mm',
    minY: 1.5,
    moduleType: 'ceiling',
    cabinetFormular: CabinetFormularTBT,
    cabinetOption: CabinetOptionTBT,
    default: {
      width: 0.8,
      height: 0.4,
      depth: 0.35,
      thickness: 0.017,
    },
    limit: {
      width: { min: 0.3, max: 1.2 },
      height: { min: 0.79, max: 0.88 },
      depth: { min: 0.59, max: 0.68 },
    },
  },
  // {
  //   id: 4,
  //   name: "TB góc vát",
  //   glbUrl: "/assets/glb/TuGocVat.glb",
  //   size: "300 - 600 mm",
  //   minY: 0,
  //   moduleType: "corner_lower",
  //   width: 0.6,
  // },
];

export const listInside = [
  {
    id: 1,
    name: 'Kệ ngang',
    // glbUrl: "/assets/glb/md1.glb",
    icon: '/assets/icons/xan-ngang.png',
    model: '/assets/glb/xanngang1.glb',
    type: 0,
  },
  {
    id: 2,
    name: 'Xắn đứng',
    icon: '/assets/icons/xan-doc.png',
    model: '/assets/glb/xandoc1.glb',
    type: 1,
  },
  {
    id: 3,
    name: 'Học tủ',
    icon: '/assets/icons/hoc-keo.png',
    model: '/assets/glb/HOCKEOBEP.glb',
    type: 3,
  },
  {
    id: 3,
    name: 'Học kéo trong tủ',
    model: '/assets/glb/HOCCHUU.glb',
    type: 4,
  },
  {
    id: 3,
    name: 'Oval treo đồ',
    model: '/assets/glb/THANHTREO.glb',
    type: 12,
    price: 55000,
  },
  {
    id: 3,
    name: 'Kệ chén',
    model: '/assets/glb/KECHEN1.glb',
    type: 7,
  },
  {
    id: 3,
    name: 'Giá để dao thớt',
    model: '/assets/glb/KECHENDUOI.glb',
    type: 6,
  },
  {
    id: 3,
    name: 'Kệ chén dĩa',
    model: '/assets/glb/KECHEN3.glb',
    type: 13,
  },
  {
    id: 3,
    name: 'Kệ xoong nồi',
    model: '/assets/glb/KECHEN4.glb',
    type: 13,
  },
  {
    id: 3,
    name: 'Thùng rác',
    model: '/assets/glb/THUNGRAC.glb',
    type: 6,
  },
];

export const listDoor = [
  {
    id: 1,
    name: 'Cửa trơn',
    icon: '/assets/icons/cua-tron.png',
    model: '/assets/demo/CUATRON.glb',
    size: '300 - 600 mm',
    limit: {
      width: { min: 0.1, max: 0.6 },
      height: { min: 0.1, max: 2 },
      depth: { min: 0.017, max: 0.02 },
    },
    moduleType: 'door',
    type: 8,
    beveled: false,
    default_handle: {
      id: 1,
      name: 'Tay nắm dài',
      icon: 'https://www.ikea.com/pimg/0753943_pe747751_s4.jpg',
      model: '/assets/glb/TAYNAMDAI.glb',
      material: 'Kẽm',
      price: 55000,
      type: 10,
    },
  },
  {
    id: 2,
    name: 'Cửa pano',
    icon: '/assets/icons/cua-pano.png',
    model: '/assets/demo/CUAPANOUV.glb',
    size: '300 - 600 mm',
    limit: {
      width: { min: 0.1, max: 0.6 },
      height: { min: 0.1, max: 2 },
      depth: { min: 0.017, max: 0.02 },
    },
    moduleType: 'door',
    type: 8,
    beveled: false,
    default_handle: {
      id: 1,
      name: 'Tay nắm tròn',
      icon: 'https://www.ikea.com/pimg/0753943_pe747751_s4.jpg',
      model: '/assets/glb/TAYNAMTRON.glb',
      material: 'Kẽm',
      price: 55000,
      type: 10,
    },
  },
];

export const listDoor45 = [
  {
    id: 1,
    name: 'Cửa trơn vát cạnh',
    icon: '/assets/icons/cua-tron-45.png',
    model: '/assets/demo/CUATRON.glb',
    size: '300 - 600 mm',
    limit: {
      width: { min: 0.1, max: 0.6 },
      height: { min: 0.1, max: 2 },
      depth: { min: 0.017, max: 0.02 },
    },
    moduleType: 'door',
    beveled: true,
    type: 8,
    default_handle: {
      id: 1,
      name: 'Tay nắm dài',
      icon: 'https://www.ikea.com/pimg/0753943_pe747751_s4.jpg',
      model: '/assets/glb/TAYNAMDAI.glb',
      material: 'Kẽm',
      price: 55000,
      type: 10,
    },
  },
  {
    id: 2,
    name: 'Cửa pano vát cạnh',
    icon: '/assets/icons/cua-pano-45.png',
    model: '/assets/demo/CUAPANO.glb',
    size: '300 - 600 mm',
    limit: {
      width: { min: 0.1, max: 0.6 },
      height: { min: 0.1, max: 2 },
      depth: { min: 0.017, max: 0.02 },
    },
    moduleType: 'door',
    beveled: true,
    type: 8,
    default_handle: {
      id: 1,
      name: 'Tay nắm dài',
      icon: 'https://www.ikea.com/pimg/0753943_pe747751_s4.jpg',
      model: '/assets/glb/TAYNAMDAI.glb',
      material: 'Kẽm',
      price: 55000,
      type: 10,
    },
  },
];

export const listMB = [
  {
    id: 1,
    name: 'Đá',
    icon: 'https://noithatgiathanh.vn/wp-content/uploads/2021/01/da-nhan-tao-solid-surface.jpg',
    type: 32,
  },
  {
    id: 1,
    name: 'Kính',
    icon: 'https://thanglongglass.com.vn/media/catalog/product/cache/f7270b00856924228e9338d04cd904f3/k/i/kinh-10mm-xanh-la-1.jpg',
    type: 32,
  },
];

export const listHandle = [
  {
    id: 1,
    name: 'Tay nắm tròn',
    icon: 'https://www.ikea.com/pimg/0753943_pe747751_s4.jpg',
    model: '/assets/glb/TAYNAMTRON.glb',
    material: 'Kẽm',
    price: 55000,
    type: 10,
  },
  {
    id: 2,
    name: 'Tay nắm dài',
    icon: 'https://www.ikea.com/pimg/0754228_pe747827_s4.jpg',
    model: '/assets/glb/TAYNAMDAI.glb',
    material: 'Nhôm',
    price: 85000,
    type: 10,
  },
];

export const modulesAutoLoad = [
  {
    id: 3,
    name: 'Học tủ bếp',
    model: '/assets/glb/HOCKEOBEP.glb',
    size: '600 - 1000 mm',
    minY: 0,
    moduleType: 'lower',
    width: 1.0,
    topGap: 0,
    bottomGap: 0,
    type: InsideType.DRAWER,
  },
];
